import './contactus.css';
import * as React from 'react'
import {Component} from "react";
import {setActiveMenuItem, setLogoWhite, setNavbarTheme} from "../../util";
import {Header} from "../../widgets";


export class ContactUs extends Component {

    componentDidMount() {
        setNavbarTheme('#040f2b');
        setActiveMenuItem('kontakt_oss', window.innerWidth < 1000);
        setLogoWhite(false);
    }

    render() {
        return (
            <div className={'default-large-cage default-vertical-cage'}>
                <div className={'contact-us'}>
                    <Header text={'Kontakt oss'}/>
                    <div className={'contact-us-contents default-center'}>
                        <ul>
                            <li>
                                <p><i className={'fa fa-envelope'}/> &nbsp;&nbsp; blonomsb@hotmail.com </p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        )
    }
}